"use client";

import React, { useState, useEffect, useCallback } from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "I walked in feeling nervous and left feeling like a goddess. This experience wasn't just about photos; it was about reclaiming my own skin.",
  name: "Elena V.",
  location: "Minneapolis, MN"
}, {
  quote: "The atmosphere was so professional yet intimate. I never knew I could look—or feel—this powerful. Truly a transformative session.",
  name: "Julianne S.",
  location: "St. Paul, MN"
}, {
  quote: "XO Boudoir captured a side of me I usually keep hidden. Seeing these images made me realize how much beauty I carry every day.",
  name: "Maya R.",
  location: "Edina, MN"
}, {
  quote: "Sophisticated, discreet, and empowering. The entire process was seamless, and the results are beyond anything I could have imagined.",
  name: "Claire T.",
  location: "Wayzata, MN"
}];
export default function WhyThisWorkIsDifferent() {
  const [api, setApi] = useState<CarouselApi>();
  const [progress, setProgress] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    if (!api) return;
    const onSelect = () => {
      setProgress(0);
    };
    api.on("select", onSelect);
    api.on("reInit", onSelect);
    return () => {
      api.off("select", onSelect);
      api.off("reInit", onSelect);
    };
  }, [api]);
  useEffect(() => {
    if (!api) return;
    const duration = 8000;
    const tick = 100;
    const increment = 100 / (duration / tick);
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          api.scrollNext();
          return 0;
        }
        return prev + increment;
      });
    }, tick);
    return () => clearInterval(timer);
  }, [api]);
  return <section data-section-id="33710" id="voices-of-empowerment" ref={ref} className={`bg-secondary py-24 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="text-xs font-sans font-medium tracking-[0.3em] text-muted-foreground uppercase mb-4">
            Voices of Empowerment
          </h2>
        </div>

        <Carousel setApi={setApi} className="w-full relative" opts={{
        loop: true,
        align: "center"
      }}>
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                  <Quote className="size-12 text-muted mb-8 opacity-30" />
                  <blockquote className="font-serif text-2xl md:text-4xl lg:text-5xl leading-tight text-foreground mb-10 max-w-3xl italic">
                    &ldquo;{item.quote}&rdquo;
                  </blockquote>
                  <div className="flex flex-col items-center gap-1">
                    <cite className="not-italic font-sans font-semibold text-lg text-foreground tracking-wide">
                      {item.name}
                    </cite>
                    <span className="text-[10px] text-muted-foreground font-sans uppercase tracking-[0.2em]">
                      {item.location}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-between mt-12 md:mt-16 px-4 md:px-12 relative">
            <CarouselPrevious variant="ghost" className="static translate-y-0 size-12 hover:bg-transparent hover:text-foreground text-muted-foreground rounded-none" />
            
            <div className="flex-1 mx-8 max-w-xs md:max-w-sm">
              <Progress value={progress} className="h-[1px] bg-border" />
            </div>

            <CarouselNext variant="ghost" className="static translate-y-0 size-12 hover:bg-transparent hover:text-foreground text-muted-foreground rounded-none" />
          </div>
        </Carousel>
      </div>
    </section>;
}